/* eslint-disable */
//tslint:disable

export interface IConditionSchema {
  /** Поле, значение которого надо сравнивать с value для определения следующего шага **/
  answerField: EAnswerField;
  /** Способ сравнения ответа на текущий вопрос с value **/
  compareType: ECompareType;
  /** Сравниваемое значение. Для compare_type!=in_list всегда сравнивается первое значение массива. **/
  value: string[];
}

export enum EAnswerField {
  /** Поле для ответа отсутствует **/
  Absent = 'absent',
  /** Укажите адрес **/
  Address = 'address',
  /** Укажите общую площадь **/
  Area = 'area',
  /** Есть, что добавить? **/
  Comment = 'comment',
  /** Как срочно хотите совершить сделку? **/
  DealPeriod = 'dealPeriod',
  /** Чем риелтор может вам помочь? так-то это dealType, только странный **/
  DealTypeEx = 'dealTypeEx',
  /** Введите адрес электронной почты **/
  Email = 'email',
  /** Новостройка или вторичка? **/
  FirstOrSecond = 'firstOrSecond',
  /** Как вас зовут? **/
  FullName = 'fullName',
  /** Включая коммунальные платежи **/
  IncludeCommunal = 'includeCommunal',
  /** Включая эксплуатационные налоги **/
  IncludeOperationalTaxes = 'includeOperationalTaxes',
  /** Объект в залоге у банка? **/
  IsBankDeposit = 'isBankDeposit',
  /** Планируете брать кредит? **/
  IsCredit = 'isCredit',
  /** Вы уже разместили объявление? **/
  IsHasOffer = 'isHasOffer',
  /** Вы получили квартиру в наследство? **/
  IsInheritance = 'isInheritance',
  /** В числе собственников есть несовершеннолетние? **/
  IsMinorOwners = 'isMinorOwners',
  /** Уже накопили на первоначальный взнос? **/
  IsMortgageInitialPayment = 'isMortgageInitialPayment',
  /** Вы готовы снизить цену, в случае необходимости? **/
  IsReadyToLower = 'isReadyToLower',
  /** Уже есть одобрение ипотеки от банка? **/
  MortgageBankApprove = 'mortgageBankApprove',
  /** Уточните тип недвижимости **/
  ObjectType = 'objectType',
  /** Какую недвижимость хотите продать? **/
  OfferType = 'offerType',
  /** Укажите номер мобильного телефона **/
  Phone = 'phone',
  /** Укажите предпочитаемую цену **/
  Price = 'price',
  /** Как планируете покупать квартиру? **/
  PurchaseMethod = 'purchaseMethod',
  /** Срок аренды **/
  RentType = 'rentType',
  /** Укажите количество комнат **/
  RoomCount = 'roomCount',
}
export enum ECompareType {
  /** Равно **/
  Eq = 'eq',
  /** Находится в списке **/
  InList = 'inList',
}
